import React, { useEffect } from "react";
import "./TranslateText.css";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import CustomLabel from "../../components/CustomLabel";
import CustomDropdown from "../../components/CustomDropdown";

/*
const HARDCODED_LANGUAGES = [
  { value: "en", name: "English" },
  { value: "fr", name: "French" },
  { value: "es", name: "Spanish" },
  { value: "de", name: "German" },
];

const HARDCODED_LOCALES = [
  { value: "es-ES", name: "Spanish-Spain" },
  { value: "es-MX", name: "Spanish-Mexico" },
  { value: "es-VE", name: "Spanish-Venezuela" },
];

const HARDCODED_VOICES = [
  { value: "es-ES-Julia", name: "Julia" },
  { value: "es-ES-Rico", name: "Rico" },
  { value: "es-ES-Juan", name: "Juan" }
];
*/

const TranslateText: React.FC = () => {
  const [sourceLanguage, setSourceLanguage] = React.useState("en");
  const [sourceText, setSourceText] = React.useState("");

  const [targetLanguages, setTargetLanguages] = React.useState<Array<{value: string, name: string}>>([]); // was HARDCODED_LANGUAGES
  const [targetLanguage, setTargetLanguage] = React.useState("");
  const [targetText, setTargetText] = React.useState("");

  const [speechLocales, setSpeechLocales] = React.useState<Array<{value: string, name: string}>>([]); // HARDCODED_LOCALES
  const [speechLocale, setSpeechLocale] = React.useState("");

  const [speechVoices, setSpeechVoices] = React.useState<Array<{value: string, name: string}>>([]); // HARDCODED_VOICES
  const [speechVoice, setSpeechVoice] = React.useState("");

  const [canTranslate, setCanTranslate] = React.useState(false);
  const [canSpeak, setCanSpeak] = React.useState(false);

  // Add this line to "use" setSourceLanguage and silence the warning
  // Until I really use it properly later
  // This is a workaround to avoid the warning about setSourceLanguage being unused
  React.useEffect(() => {}, [setSourceLanguage]);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  /*
  const serviceClient = useServiceClient();

  // Example function to fetch data from an API endpoint
  const fetchData = async () => {
    const response = await serviceClient.request<MyDataType>("/api/my-endpoint", "GET");
    if (response.data) {
      // handle data
    } else {
      // handle error
    }
  };
  */

  // You might call fetchData in a useEffect or on a button click
  // useEffect(() => { fetchData(); }, []);  

  const handleTranslateButtonClick = () => {
    const apiEndPoint = "/language/TranslateText";
    let apiUrl = apiBaseUrl + apiEndPoint;
    apiUrl += `?sourceLanguage=${encodeURIComponent(sourceLanguage)}`;
    apiUrl += `&sourceText=${encodeURIComponent(sourceText)}`;
    apiUrl += `&targetLanguage=${encodeURIComponent(targetLanguage)}`;

    console.info("Sending [" + apiUrl + "]");

    // Call the API
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP API call failed with status: ${response.status}`);
      }
      // Return a promise which might reject if the response is not JSON
      return response.json();
    })
    .then(result => {
      console.log("Successfully parsed JSON: ", result);
      // Process the data
      if (result.isSuccess)
      {
        const translatedText = result?.success?.data?.translatedText;
        setTargetText(typeof translatedText === "string" ? translatedText : "");
      }
      else
      {
        alert(result.error.message);
        setTargetText("");
      }
    })
    .catch(error => {
      console.error("Error during fetch API call or JSON parsing: ", error);
      // Handle the error eg display message to the user
      alert("An error occurred while calling the API. Please try again. Error details: " + error.message);
    });
  };

  const handleSpeakButtonClick = () => {
    const apiEndPoint = "/language/TextToSpeech";
    let apiUrl = apiBaseUrl + apiEndPoint;
    apiUrl += `?text=${encodeURIComponent(targetText)}`;
    apiUrl += `&speechLanguage=${encodeURIComponent(targetLanguage)}`;
    apiUrl += `&voice=${encodeURIComponent(speechVoice)}`;

    console.info("Sending [" + apiUrl + "]");

    // Call the API
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP API call failed with status: ${response.status}`);
      }
      // Return a promise which might reject if the response is not JSON
      return response.json();
    })
    .then(result => {
      console.log("Successfully parsed JSON: ", result);
      
      if (result.isSuccess)
      {
        // Assuming the API returns a URL to the audio file
        /*
        const audioUrl = result.success.data;
        const audioElement = document.querySelector("audio");
        if (audioElement) {
          const sourceElement = audioElement.querySelector("source");
          if (sourceElement) {
            sourceElement.src = audioUrl;
            audioElement.load(); // Load the new audio source
          }
        }
        */
        //Buffer.from
        const base64data = result?.success?.data?.audioData;
        if (typeof base64data !== "string") {
          alert("The API did not return audio data in the expected format.");
          return;
        }
        let binaryData = atob(base64data);
        let binaryArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          binaryArray[i] = binaryData.charCodeAt(i);
        }
        let audioBlob = new Blob([binaryArray], { type: 'audio/wav' });
        let audioUrl = URL.createObjectURL(audioBlob);

        let myAudio: HTMLAudioElement | null = document.getElementById("myAudio") as HTMLAudioElement | null;
        myAudio?.setAttribute("src", audioUrl);
        myAudio?.load();
        myAudio?.play();

        /*
        const audioElement = document.querySelector("audio");
        if (audioElement) {
          const sourceElement = audioElement.querySelector("source");
          if (sourceElement) {
            sourceElement.src = audioUrl;
            audioElement.load(); // Load the new audio source
            audioElement.play();
          }
        }
          */
        //setLabelValue("Success");
      }
      else
        alert(result.error.message);
    })
    .catch(error => {
      console.error("Error during fetch API call or JSON parsing: ", error);
      // Handle the error eg display message to the user
      alert("An error occurred while calling the API. Please try again. Error details: " + error.message);
    });
  };

  const handleSourceTextInputChange = (value: string) => {
    setSourceText(value);
  }

  const handleTargetTextChange = (value: string) => {
    
  }

  const handleTargetLanguageDropdownChange = (value: string) => 
  {
    setTargetLanguage(value);
    setSpeechLocale("");
    setSpeechVoice("");
  }

  const handleSpeechLocaleDropdownChange = (value: string) => setSpeechLocale(value);

  const handleSpeechVoiceDropdownChange = (value: string) => setSpeechVoice(value);

  // To call an API function whenever targetLanguage changes, use a useEffect hook 
  // that lists targetLanguage as a dependency. This hook will run every time targetLanguage 
  // changes (including the first render if it's not empty).
  useEffect(() => {
    if (targetLanguage) {
      // Call your API function here
      // For example:
      const apiEndPoint = "/content/LanguageLocales";
      let apiUrl = apiBaseUrl + apiEndPoint;
      apiUrl += `?language=${encodeURIComponent(targetLanguage)}`;

      fetch(apiUrl)
        .then(res => res.json())
        .then(result => {
          const locales = result?.success?.data?.locales;
          setSpeechLocales(Array.isArray(locales) ? locales : []);
        })
        .catch(err => {
          // handle error
        });
    }
    // Yes, you should add apiBaseUrl as a dependency in your useEffect if you use it
    // inside the effect. This ensures that if apiBaseUrl ever changes, your effect 
    // will re-run with the new value.
  }, [targetLanguage, apiBaseUrl]);

  useEffect(() => {
    if (speechLocale) {
      // Call your API function here
      // For example:
      const apiEndPoint = "/content/LocaleVoices";
      let apiUrl = apiBaseUrl + apiEndPoint;
      apiUrl += `?locale=${encodeURIComponent(speechLocale)}`;

      fetch(apiUrl)
        .then(res => res.json())
        .then(result => {
          const voices = result?.success?.data?.voices;
          setSpeechVoices(Array.isArray(voices) ? voices : []);
        })
        .catch(err => {
          // handle error
        });
    }
  }, [speechLocale, apiBaseUrl]);

  // can translate if input has text (=> sourceLanguage) and dropdown has selection (=> targetLanguage)
  useEffect(() => {
    setCanTranslate(sourceText.length > 0 && targetLanguage.length > 0);
  }, [sourceText, targetLanguage]);

  // can translate if input has text (=> sourceLanguage) and dropdown has selection (=> targetLanguage)
  useEffect(() => {
    setCanSpeak(targetText.length > 0 && speechLocale.length > 0 && speechVoice.length > 0);
  }, [targetText, speechLocale, speechVoice]);

  // Auto-select the first locale when speechLocales changes
  useEffect(() => {
    if (speechLocales.length > 0) {
      setSpeechLocale(speechLocales[0].value);
    }
  }, [speechLocales]);

  // Auto-select the first voice when speechVoices changes
  useEffect(() => {
    if (speechVoices.length > 0) {
      setSpeechVoice(speechVoices[0].value);
    }
  }, [speechVoices]);

  // This correctly fetches languages from the API
  useEffect(() => {
    const getTargetLanguages = () => {
      const apiEndPoint = "/content/Languages";
      const apiUrl = apiBaseUrl + apiEndPoint;
      console.info("Sending [" + apiUrl + "]");

      // Call the API
      fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP API call failed with status: ${response.status}`);
        }
        // Return a promise which might reject if the response is not JSON
        return response.json();
      })
      .then(result => {
        console.log("Successfully parsed JSON: ", result);
        // Process the data
        if (result.isSuccess) {
          const languages = result?.success?.data?.languages;
          setTargetLanguages(Array.isArray(languages) ? languages : []);
        }
        //else
          //setTranslation(result.error.message);
        })
      .catch(error => {
        console.error("Error during fetch API call or JSON parsing: ", error);
        // Handle the error eg display message to the user
        alert("An error occurred while calling the API. Please try again. Error details: " + error.message);
      });
    };
    getTargetLanguages();
  }, [apiBaseUrl]);

  //const [data, setData] = React.useState<Item[]>([]); // State to store API response

  /*
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://your-api-url.com/data");
        const result: Item[] = await response.json();
        setData(result); // Store API response in state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
*/

  return (
    <span className="translate-text-container">
      <CustomLabel text="Translate" />
      <CustomInput text={sourceText} onChange={handleSourceTextInputChange} />

      <CustomLabel text="into" />
      <CustomDropdown prompt="Language" value={targetLanguage} options={targetLanguages} onChange={handleTargetLanguageDropdownChange} />

      <CustomButton label="Translate" onClick={handleTranslateButtonClick} disabled={!canTranslate} />
      <CustomInput text={targetText} onChange={handleTargetTextChange} />
      
      <CustomLabel text="and speak in locale" />
      <CustomDropdown prompt="Locale" value={speechLocale} options={speechLocales} onChange={handleSpeechLocaleDropdownChange} />
      
      <CustomLabel text="voice" />
      <CustomDropdown prompt="Voice" value={speechVoice} options={speechVoices} onChange={handleSpeechVoiceDropdownChange} />
      
      <CustomButton label="Speak" onClick={handleSpeakButtonClick} disabled={!canSpeak} />

      <audio id="myAudio" controls>
        <source src="path_to_your_audio_file.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
  </span>
  );
};

export default TranslateText;
